var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","duration":700,"name":"flash"}},[(_vm.currentItem)?_c('UIFlash',_vm._b({key:_vm.currentItem.id,staticClass:"flash"},'UIFlash',_vm.currentItem,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }